// extracted by mini-css-extract-plugin
module.exports = {"close-btn":"close-button_close-btn__2x3Lz"};